export enum TimesheetStatusReportFilterTypes {
  ApprovalState = 'approvalState',
  Customer = 'customer',
  Worker = 'worker',
  Member = 'member',
  Date = 'date',
}
